<script>
  import { onMount } from "svelte";
  import { initializeApp } from "firebase/app";
  import { getDatabase, ref, runTransaction } from "firebase/database";

  // 🔹 Firebase config
  const firebaseConfig = {
    apiKey: "AIzaSyDK0IQX9oa3P2OgltxrLJ8F1vZnO27KaFU",
    authDomain: "fetchersandscrapers-386908.firebaseapp.com",
    databaseURL: "https://fetchersandscrapers-386908-abfa2.firebaseio.com",
    projectId: "fetchersandscrapers-386908",
    storageBucket: "fetchersandscrapers-386908.firebasestorage.app",
    messagingSenderId: "9750758445",
    appId: "1:9750758445:web:35bf613dfaa69265ed64a4",
    measurementId: "G-KF4DD42F51"
  };
   const app = initializeApp(firebaseConfig);
  const db = getDatabase(app);


  function isInIFrameSafe() {
  try { return window.self !== window.top; } catch { return true; }
}

  // RTDB keys får inte innehålla . # $ [ ]
  function safeKey(str = "") {
    return String(str)
      .trim()
      .toLowerCase()
      .replace(/\./g, "_")
      .replace(/#/g, "_")
      .replace(/\$/g, "_")
      .replace(/\[/g, "_")
      .replace(/\]/g, "_")
      .replace(/\s+/g, "_");
  }

  function getTitelFromUrl() {
    try {
      const u = new URL(window.location.href);
      return u.searchParams.get("titel"); // ex "op"
    } catch {
      return null;
    }
  }

  // Försök identifiera “webview/app” ungefärligt (heuristik)
  function detectWebView() {
    const ua = navigator.userAgent || "";
    const isIOSWebView = /iP(hone|od|ad)/.test(ua) && !/Safari/.test(ua);
    const isAndroidWebView =
      /Android/.test(ua) && (/wv/.test(ua) || /Version\/\d+\.\d+/.test(ua));
    return isIOSWebView || isAndroidWebView;
  }

  // Försök läsa parent/top href (kan bli null pga cross-origin)
  function tryGetAncestorHrefs() {
    const out = {
      self: window.location.href,
      parent: null,
      top: null
    };

    try {
      out.parent = window.parent?.location?.href || null;
    } catch {}

    try {
      out.top = window.top?.location?.href || null;
    } catch {}

    return out;
  }

  async function registerByTitelAndHref() {
    const titelRaw = getTitelFromUrl();
    const titel = titelRaw && String(titelRaw).trim() ? titelRaw : "okand";
    const titelKey = safeKey(titel);

    const hrefs = tryGetAncestorHrefs();
    const isIframed = isInIFrameSafe();
    const isWebView = detectWebView();

    // Spara per titel
    const titleRef = ref(db, `widget_embed_hosts/by_title/${titelKey}`);

    await runTransaction(titleRef, (current) => {
      const now = Date.now();

      const next = {
        count: 1,
        firstSeenAt: now,
        lastSeenAt: now,

        // senaste href vi kan se
        lastHrefSelf: hrefs.self,
        lastHrefParent: hrefs.parent, // null om blockad
        lastHrefTop: hrefs.top,       // null om blockad

        isIframed,
        isWebView
      };

      if (current === null) return next;

      return {
        ...current,
        count: (current.count || 0) + 1,
        firstSeenAt: current.firstSeenAt || now,
        lastSeenAt: now,

        lastHrefSelf: hrefs.self,
        lastHrefParent: hrefs.parent,
        lastHrefTop: hrefs.top,

        isIframed,
        isWebView
      };
    });
  }

  onMount(() => {
    registerByTitelAndHref().catch((e) =>
      console.error("EmbedTracker error:", e)
    );
  });
</script>